<template>
  <button class="base-scroll-button"
          type="button"
          @click="$emit('click')">
    <component :is="direction === 'left' ? 'icon-arrow-left' : 'icon-arrow-right'"
               class="icon"
               width="16"
               height="16"/>
  </button>
</template>

<script>
  export default {
    props: {
      direction: {
        required: true,
        type: String
      }
    }
  }
</script>

<style lang="scss" scoped>
  .base-scroll-button {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 50%;
    background-color: #fff;
    cursor: pointer;
    transition: all .1s ease-out;

    &:hover {
      background-color: darken(#fff, 5%);
      box-shadow: 0 1px 4px 0 rgba(#000, .2);
    }

    &:active {
      background-color: darken(#fff, 10%);
      box-shadow: 0 0 1px 0 rgba(#000, .2);

      .icon {
        color: #6d6c6c;
      }
    }
  }

  .icon {
    color: #999;
  }
</style>
